module.exports = __webpack_public_path__ + "static/home-1-ca6778e79137f2078ca6f4663a4c5ea9.jpg";